import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DetailPair } from '../../../../../../../shared/components/detail-info-card/DetailPair';
import { DataUtility } from '../../../../../../../utilities/DataUtility';
import { EquifaxDetailCardComponent } from '../equifax-detail-card/equifax-detail-card.component';


@Component({
  selector: 'app-guest-dob-result-card',
  templateUrl: './guest-dob-result-card.component.html',
  styleUrls: ['./guest-dob-result-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    EquifaxDetailCardComponent
  ]
})
export class GuestDobResultCardComponent implements OnInit {

  @Input() guest!: any;

  data: DetailPair[] = [];
  title = 'DOB Trust';
  trustDecision!: string;

  dobAffiliationReason!: string;
  dobVerificationReason!: string;
  dobInsightsReason!: string;

  constructor(private dataUtility: DataUtility) { }

  ngOnInit() {
    this.dobAffiliationReason = this.dataUtility.getCheckReason(this.guest, 'dobAffiliationReason');
    this.dobVerificationReason = this.dataUtility.getCheckReason(this.guest, 'dobVerificationReason');
    this.dobInsightsReason = this.dataUtility.getCheckReason(this.guest, 'dobInsightsReason');

    this.populateDobTrustInfo();
  }

  populateDobTrustInfo() {
    this.trustDecision = this.dataUtility.getTrustInfo(this.guest, 'dobTrust');

    this.data.push(new DetailPair("Affiliation", this.dataUtility.getTrustInfo(this.guest, 'dobAffiliation') ? this.dataUtility.getTrustInfo(this.guest, 'dobAffiliation') : null, this.dobAffiliationReason));
    this.data.push(new DetailPair("Verification", this.dataUtility.getTrustInfo(this.guest, 'dobVerification') ? this.dataUtility.getTrustInfo(this.guest, 'dobVerification') : null, this.dobVerificationReason));
    this.data.push(new DetailPair("Insights", this.dataUtility.getTrustInfo(this.guest, 'dobInsights') ? this.dataUtility.getTrustInfo(this.guest, 'dobInsights') : null, this.dobInsightsReason));
  }

}